import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { WaybillIdView } from '../../../../models/shipment-id-view.model';
import { API_URL } from '../../../../../services/config';
import { ShipmentWaybillEndpoint } from '../../constants/shipment-waybill-endpoint';
import { Observable } from 'rxjs';
import { ShipmentWaybillStatusHistory } from '../../models/shipment-waybill-status-history.model';
import { getQueryStringFromObject } from '../../../../../common/utils';

@Injectable({ providedIn: 'root' })
export class ShipmentWaybillStatusHistoryService {
  constructor(private http: WrapperHttpService) {}

  getStatusHistoryData(waybillIdView: WaybillIdView): Observable<ShipmentWaybillStatusHistory> {
    const url = `${API_URL}${ShipmentWaybillEndpoint.Base}${ShipmentWaybillEndpoint.Waybills}${
      ShipmentWaybillEndpoint.StatusHistory
    }?${getQueryStringFromObject({
      ...waybillIdView,
    })}`;

    return this.http.withLoading().get(url);
  }
}
